import React from 'react';
import css from './Map.css';

const Map = () => {

  return (
    <div className={css.map}>
      {/* <iframe width="100%" height="650" title="google maps ellevoro restaurant" src="https://maps.google.com/maps?q=Rovertou%20Galli%202%20Athens&t=&z=17&ie=UTF8&iwloc=&output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe> */}
      <iframe title="google maps ellevoro restaurant" src="https://snazzymaps.com/embed/185703"></iframe>
    </div>
  );
}

export default Map;
